import { autoinject, bindable, bindingMode, customElement } from 'aurelia-framework';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { BaseCustomElement } from 'Common/BaseCustomElement';
import { Config } from 'Config';
import { SystemService } from 'DataAccessLayer/Services/SystemService';

@autoinject
@customElement('clinic-row')
export class ClinicRowCustomElement extends BaseCustomElement {
    @bindable({ defaultBindingMode: bindingMode.toView }) quoteIssued: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) index: number = null;
    

    private async  QuoteIssuedPdf(quoteIssuedId: number){
        let reportServerUrl = Config.ApiUrl() + '/GetReport/';
        reportServerUrl += quoteIssuedId+ '?reportMode=OneByOneId';
        reportServerUrl += '&exportType=' + 'PDF';
        reportServerUrl += '&rdlReportName=' + 'QuoteIssued';
        reportServerUrl += '&reportName=' + 'Nab%C3%ADdka%20vydan%C3%A1';
        reportServerUrl += '&entityName=' + 'QuoteIssued';
        reportServerUrl += '&languageCode=' + 'cs-CZ';
        reportServerUrl += '&isCustom=' + 'false';
        reportServerUrl += '&ids=';
        reportServerUrl += '&userToken=' + JSON.parse(localStorage[Config.TokenName()] || null).Token;
        reportServerUrl += '&reportJsonData=' + window.btoa(encodeURIComponent(JSON.stringify({})));

        if (await SystemService.Instance.GetSchemaProperty('ReportOpenInNewTab')) {
            window.open(reportServerUrl, '_blank');
        }
        else {
            window.location.href = reportServerUrl;
        }
    }
}